// JOURNEY BUILDER CUSTOM ACTIVITY - ProfileRefresh ACTIVITY
// ````````````````````````````````````````````````````````````
// This is a custom activity that retrieves up-to-date data from Data Cloud for this contact.
//
// Journey Builder's Postmonger Events Reference can be found here:
// https://developer.salesforce.com/docs/atlas.en-us.noversion.mc-app-development.meta/mc-app-development/using-postmonger.htm

import React from 'react';
import { SimpleConfigurationPage } from './features/simpleConfigurationPage/simpleConfigurationPage';
import { createRoot } from 'react-dom/client';
import { setupExampleTestHarness } from './testHarness';
import { store } from './store';
import { Provider } from 'react-redux';
import {
    GetActivity,
    GetSchema,
    subscribe,
} from '../../../lib/common/postmonger/postmongerManager';
import {
    updateActivity,
    updateSchema,
} from '../../../lib/client/features/journeyBuilder/journeySlice';
import {
    Activity,
    Schema,
} from '../../../lib/common/custom-activity/eventTypes';

// Set up some testing hooks before we mount the UI
setupExampleTestHarness();

// The store can be updated asynchronously from Journey Builder.
// Attach these here to avoid circular imports between the store and
// the postmonger manager.
function attachGlobalAsyncStoreUpdaters() {
    // Update the store if Journey Builder has already provided our data.
    const currentActivity = GetActivity();
    if (currentActivity) {
        store.dispatch(updateActivity(currentActivity));
    }

    const currentSchema = GetSchema();
    if (currentSchema) {
        store.dispatch(updateSchema(currentSchema));
    }

    // Subscribe to new updates to keep the store in sync
    subscribe('onActivity', (activity: Activity) => {
        // Update the Redux store
        store.dispatch(updateActivity(activity));
    });

    subscribe('onSchema', (schema: Schema) => {
        // Update the Redux store
        store.dispatch(updateSchema(schema));
    });
}
attachGlobalAsyncStoreUpdaters();

// Mount the UI
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <SimpleConfigurationPage />
    </Provider>,
);
